// components/RestaurantDirectory/RestaurantDirectory.jsx
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./restaurant-directory.css";
import { API_BASE_URL } from "../../config";

// The homepage entry point into ordering - picking a restaurant here is
// what takes a customer to that restaurant's own menu (and, from then on,
// scopes their cart to it). Only ever shows active restaurants; a
// temporarily-hidden one just isn't listed.
const RestaurantDirectory = () => {
  const [restaurants, setRestaurants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const fetchRestaurants = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/restaurant`);
        setRestaurants(response.data.restaurants || []);
      } catch (error) {
        console.error("Error fetching restaurants:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchRestaurants();
  }, []);

  if (!loading && restaurants.length === 0) return null;

  // Client-side filter, not a server search endpoint - the restaurant
  // count here is small enough (a handful, growing slowly) that filtering
  // the already-fetched list is simpler and just as fast.
  const query = search.trim().toLowerCase();
  const filteredRestaurants = query
    ? restaurants.filter((r) => r.name.toLowerCase().includes(query))
    : restaurants;

  return (
    <section className="restaurant-directory" id="restaurants">
      <div className="restaurant-directory-container">
        <span className="eyebrow">Order From</span>
        <h2 className="restaurant-directory-title">Our Restaurants</h2>

        {!loading && (
          <input
            type="text"
            placeholder="Search restaurants…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="restaurant-directory-search"
          />
        )}

        {!loading && filteredRestaurants.length === 0 && (
          <p className="restaurant-directory-empty">No restaurants match "{search}".</p>
        )}

        <div className="restaurant-directory-grid">
          {loading
            ? Array.from({ length: 3 }).map((_, i) => (
                <div key={i} className="restaurant-card restaurant-card-skeleton" />
              ))
            : filteredRestaurants.map((restaurant) => (
                <Link
                  key={restaurant._id}
                  to={`/menu/${restaurant.slug}`}
                  className="restaurant-card"
                >
                  {restaurant.image && (
                    <img
                      src={restaurant.image}
                      alt={restaurant.name}
                      className="restaurant-card-img"
                    />
                  )}
                  <div className="restaurant-card-body">
                    <h3 className="restaurant-card-title">{restaurant.name}</h3>
                    {restaurant.description && (
                      <p className="restaurant-card-desc">{restaurant.description}</p>
                    )}
                    <span className="restaurant-card-cta">View Menu →</span>
                  </div>
                </Link>
              ))}
        </div>
      </div>
    </section>
  );
};

export default RestaurantDirectory;
